module.exports = __webpack_public_path__ + "img/entra_id_sync.39bd9092.svg";